import ApiClient from "../helpers/ApiClient";

export const initChatSession = async (visitorName, visitorPhone, sessionId) => {
    try {
        const response = await ApiClient.post("/chatbot/init", { visitor_name: visitorName, visitor_phone: visitorPhone, sessionId });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const sendChatMessage = async (sessionId, message) => {
    try {
        const response = await ApiClient.post("/chatbot/message", { session_id: sessionId, message });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getFaqs = async () => {
    try {
        const response = await ApiClient.get("/chatbot/faqs");
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const addFaq = async (formData) => {
    try {
        const response = await ApiClient.post("/chatbot/faqs", formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const editFaq = async (id, formData) => {
    try {
        const response = await ApiClient.put(`/chatbot/faqs/${id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteFaq = async (id) => {
    try {
        const response = await ApiClient.delete(`/chatbot/faqs/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const uploadBulkFaqs = async (faqs) => {
    try {
        const response = await ApiClient.post("/chatbot/faqs/bulk", { faqs });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getChatSessions = async () => {
    try {
        const response = await ApiClient.get("/chatbot/sessions");
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getChatMessages = async (sessionId) => {
    try {
        const response = await ApiClient.get(`/chatbot/sessions/${sessionId}/messages`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const replyToChat = async (sessionId, message) => {
    try {
        const response = await ApiClient.post(`/chatbot/sessions/${sessionId}/reply`, { message });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const markSessionResolved = async (sessionId) => {
    try {
        const response = await ApiClient.post(`/chatbot/sessions/${sessionId}/resolve`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
